import { fetchInvites, fetchSessions } from 'src/v3/events/events.slice'
import { createListenerMiddleware } from '@reduxjs/toolkit'
import { EventSession } from '../core/types'

export let listenerMiddleware = createListenerMiddleware()

listenerMiddleware.startListening({
  actionCreator: fetchSessions.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.cancelActiveListeners()

    action.payload.forEach((s: EventSession) => {
      listenerApi.dispatch(fetchInvites(s.id))
    })
  },
})
